import { ServiceState } from './service.state';
import * as fromAction from './service.action';
import { adapter } from './service.entity';
import { Action, createReducer, on } from '@ngrx/store';
import { ServiceFilter } from '../../models/service-filter';

export const SERVICE_PAGE_SIZE = 12;

export const initialState: ServiceState = adapter.getInitialState({
    error: null,
    totalCount: 0,
    filter: new ServiceFilter(),
    servicePagination: {
        pageIndex: 0,
        pageSize: SERVICE_PAGE_SIZE,
    }
});

const reducer = createReducer(
    initialState,
    on(fromAction.AddService, (state, { service }) => {
        return adapter.addOne(service, state);
    }),

    on(fromAction.AddServices, (state, { services }) => {
        return adapter.setAll(services, state);
    }),

    on(fromAction.AddServices, (state, { services }) => {
        return adapter.upsertMany( services , state);
    }),

    on(fromAction.RemoveAllServices, (state) => {
        return adapter.setAll([],state);
    }),

    on(fromAction.AddServiceFilter, (state, {filters}) => {
        return adapter.addMany([], { ...state, filter: filters});
    }),

    on(fromAction.ResetServiceFilter, (state) => {
        return {...state, filter:{...(new ServiceFilter())}};
    }),

    on(fromAction.AddServicePagination, (state,{ servicePagination: { pageIndex, pageSize = SERVICE_PAGE_SIZE } }) => {
        return {...state, servicePagination: { pageSize, pageIndex }};
    }),

    on(fromAction.UpdateService, (state, { id, change }) => {
        return adapter.updateOne( {id: id, changes: change}, state);
    }),

    on(fromAction.DeleteService, (state, { id }) => {
        return adapter.removeOne( id, state);
    }),

    on(fromAction.AddServicesTotalCount, (state, { totalCount }) => {
        return adapter.addMany([], { ...state, totalCount: totalCount });
    }),

    on(fromAction.AddError, (state, { error }) => {
        return adapter.addMany([], { ...state, error: error });
    }),

    on(fromAction.DeleteServiceMedia, (state, { serviceId, fileName }) => {
        const entity = JSON.parse(JSON.stringify(({ ...state.entities[serviceId] })));
            if (entity) {
                const index = entity.media.findIndex(p => p.name === fileName);
                entity.media.splice(index, 1);
                return {
                    ...adapter.updateOne({ id: serviceId, changes: entity }, state)
                };
            }

        return state;
    }),

    on(fromAction.AddServiceMedia, (state, { serviceId, medias }) => {
        const entity = JSON.parse(JSON.stringify(({ ...state.entities[serviceId]})));
            if (entity) {
                for (const media of medias) {
                    entity.media.push(media);
                }
                return {
                    ...adapter.updateOne({ id: serviceId, changes: entity }, state)
                };
            }

        return state;
    }),

    on(fromAction.AddServiceSchedule, (state, { serviceId, schedules }) => {
        const entity = JSON.parse(JSON.stringify(({ ...state.entities[serviceId]})));
            if (entity) {
                if (entity.schedules === undefined) {
                    entity.schedules = [];
                }
                for (const schedule of schedules) {
                    if (!entity.schedules.find(x => x.id === schedule.id)) {
                        entity.schedules.push(schedule);
                    }
                }
                return {
                    ...adapter.updateOne({ id: serviceId, changes: entity }, state)
                };
            }

        return state;
    }),

    on(fromAction.DeleteServiceSchedule, (state, { serviceId, scheduleId }) => {
        const entity = JSON.parse(JSON.stringify(({ ...state.entities[serviceId] })));
            if (entity) {
                const index = entity.schedules.findIndex(x => x.id === scheduleId);
                entity.schedules.splice(index, 1);
                return {
                    ...adapter.updateOne({ id: serviceId, changes: entity }, state)
                };
            }
        return state;
    }),

    on(fromAction.AddServiceDefaultImage, (state, { serviceId, media }) => {
        const entity = JSON.parse(JSON.stringify(({ ...state.entities[serviceId] })));

        if (entity) {
            // remove the new default from store for replace
            const index = entity.media.findIndex(p => p.name === media.name);
            entity.media.splice(index, 1);

            const oldDefaultIndex = entity.media.findIndex(p => p.default);
            if (oldDefaultIndex >= 0) {
                entity.media[oldDefaultIndex].default = false;
            }
            entity.media.unshift(media);

            return {
                ...adapter.updateOne({ id: serviceId, changes: entity }, state)
            };
        }

        return state;
    }),

    on(fromAction.RemoveServiceFilter, (state, { }) => {
        return adapter.addMany([], { ...state, filter: new ServiceFilter()});
    }),

);


export function experienceStoreReducer(state: ServiceState = initialState, action: Action): ServiceState {
    return reducer(state, action);
}
